var path = '/pages/guestlists/views/pages/guestlists/messages/sent.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<section ng-if=\"!vm.loading\" id=\"guestlists_editor_tickets\">\n    <listview store=\"vm.store\"></listview>\n</section>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/messages/sent.tpl.html
// module id = 2262
// module chunks = 1